export const PROFESSIONAL = 1;
export const ACADEMIC_PRIMARY = 2;
export const ACADEMIC_COLLEGE = 3;